<p>update-biometric-info works!</p>
